/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import PerfectScrollbar from "react-perfect-scrollbar";
import { toAbsoluteUrl } from "../../../../../_helpers";
import { Link } from "react-router-dom";

const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};

export function SearchResult({ onClickLink, data }) {
  if (!data) {
    return null;
  }


  if (data.length === 0) {
    return (
      <div
        style={{ maxHeight: "325px", overflow: "scroll" }}
        className="quick-search-wrapper scroll ps ps--active-y"
      >
        <div className="quick-search-result">
          <div className="text-muted d-none">No record found</div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="quick-search-wrapper scroll ps ps--active-y"
    >
      <PerfectScrollbar
        options={perfectScrollbarOptions}
        className="scroll"
        style={{ maxHeight: "600px", overflowY: "scroll", position: "relative" }}
      >
        <div className="quick-search-result">
          {/* begin: Section */}

          {data.map(({ id, type, text, description, extra }) =>
            type === 0 ?
              <div className="font-size-sm text-primary font-weight-bolder text-uppercase mb-1">
                {text}
              </div>
              :
              <div className="mb-2">
                <div className="d-flex align-items-center flex-grow-1">
                  <div className="ml-3 mt-1">
                    {type === "product"
                      &&
                      <Link to={`/portal/products/${id}/links/0`} onClick={() => onClickLink()}>{text}</Link>
                    }
                    {type === "seller"
                      &&
                      <>
                      <Link to={`/portal/sellers/${id}/links`} onClick={() => onClickLink()}>{text}</Link>
                      <span style={{ margin: "0 10px", color: "#a2a3b7" }}>({extra})</span>
                      </>
                    }
                    {(type !== "seller" && type !== "product") &&
                      <a
                        href="#"
                        className="font-weight-bold text-dark text-hover-primary"
                      >
                        {text}
                      </a>
                    }
                  </div>
                </div>
              </div>
          )}
          {/* end: Section */}

        </div>
      </PerfectScrollbar>
    </div>
  );
}
